export const CAPTCHA_EVENTS = [
  "captcha_shown",
  "captcha_solved",
  "captcha_failed",
  "captcha_sdk_load_failed",
  "captcha_retry_result",
] as const;

export type CaptchaEvent = (typeof CAPTCHA_EVENTS)[number];

export interface CaptchaEventPayload {
  event: CaptchaEvent;
  /** Pathname of the POST that tripped the CAPTCHA rule. */
  path?: string;
  /** Milliseconds the puzzle was on screen (solved/failed only). */
  durationMs?: number;
  /** Failure detail (failed / sdk_load_failed only). */
  reason?: string;
  /** HTTP status of the retried POST (captcha_retry_result only). */
  status?: number;
}

export const DEFAULT_CAPTCHA_LOG_PATH = "/api/captcha-log";

/**
 * Fire-and-forget beacon to the app's captcha-log route, which turns it into a
 * Datadog log line and a `marketing_sites.frontend.captcha.*` count.
 *
 * `keepalive` is doing two jobs: it survives the unload a solved submit often
 * triggers, and it is the same signal `isInterruptibleSubmit` uses to skip
 * beacons — so this POST can never itself pop a puzzle.
 */
export function reportCaptchaEvent(
  logPath: string,
  payload: CaptchaEventPayload,
): void {
  try {
    void window
      .fetch(logPath, {
        method: "POST",
        keepalive: true,
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
      })
      .catch(() => {});
  } catch {
    // Telemetry must never break the submit it is observing.
  }
}
